import * as React from 'react';
import { Tooltip } from 'antd';
import { AbstractTooltipProps } from 'antd/lib/tooltip';

interface Props extends AbstractTooltipProps {
    content: React.ReactNode;
}

const tooltipStyle = {
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    padding: '4px 8px',
};

export const AntTooltip: React.FC<Props> = ({ content, children, ...restProps }) => {
    return (
        <Tooltip
            {...restProps}
            overlayInnerStyle={tooltipStyle}
            title={<span className="font-lato font-700 text-white text-12">{content}</span>}
        >
            {children}
        </Tooltip>
    );
};
